import {
  formSpecification as commonFormSpecification,
  type McaPersonDetailsFormData as CommonMcaPersonDetailsFormData,
} from "../common/mcaPersonDetails.js";

export const formSpecification = commonFormSpecification;

export type McaPersonDetailsFormData = CommonMcaPersonDetailsFormData;
